import {privacyPolicyURL} from "../../helpers/constants";
import React from 'react'
import {localize} from "../../helpers/functions";
import {localStorageKeys, operations} from "../../helpers/enums";

const PrivacyPolicy = props => {

    const Submit = (action) => {
        action === 1 ? localStorage.setItem(localStorageKeys.acceptPolicy,true) : localStorage.setItem(localStorageKeys.operatorName,operations.yabadoo)
        window.location.reload()
    }

    return (
        <div className="webview-container">
            <iframe src={privacyPolicyURL}/>
            <div className="button-container">
                <button onClick={() => Submit(1)}>{localize('confirm')}</button>
                <button onClick={() => Submit(0)}>{localize('cancel')}</button>
            </div>
        </div>
    )
}

export default PrivacyPolicy
